module.exports = __webpack_public_path__ + "static/media/Cecil-icon-01-01-xmd.cf65dbe1.png";